import React from 'react';
import data from './data';
import ProDeskCardGrid from '../ProDeskCardGrid/ProDeskCardGrid';

export const ProDeskResources = () => (
  <div className="sui-mt-10" data-component="ProDeskResources">
    <ProDeskCardGrid
      title="Pro Resources"
      data={data}
      trackingParam="?emt=PD_proresources"
      ctaText="Learn More"
    />
  </div>
);

ProDeskResources.displayName = 'ProDeskResources';